export default "__VITE_ASSET__G2dsGr68__"